import { Account } from './account';
import { Company } from './company';
import { InstitutionSource } from './institution';
import { User } from './user';

export enum UserBankAccountStatus {
  INVITATION_SENT = 'INVITATION_SENT',
  ENABLED = 'ENABLED',
  SUSPENDED = 'SUSPENDED',
  DISABLED = 'DISABLED',
  BINDING_USER_ERROR = 'BINDING_USER_ERROR',
}

export enum UserBankAccountBindingError {
  FIRST_NAME_MATCH_ERROR = 'first_name_match_error',
  LAST_NAME_MATCH_ERROR = 'last_name_match_error',
  BIRTH_DATE_MATCH_ERROR = 'birth_date_match_error',
  PHONE_NUMBER_MATCH_ERROR = 'phone_number_match_error',
  EMAIL_VERIFIED_MATCH_ERROR = 'email_verified_match_error',
  ID_VERIFIED_MATCH_ERROR = 'id_verified_match_error',
}

export interface UserBankAccount {
  id: string;
  bindingErrors: UserBankAccountBindingError[] | null;
  sourceId: string;
  source: InstitutionSource;
  status: UserBankAccountStatus;
  user: User | null;
  bankAccount: Account | null;
  canViewAccount: boolean;
  canInitiatePayments: boolean;
  canManageBeneficiaries: boolean;
  canManageAccountMembership: boolean;
  canManageCards: boolean;
}

export interface GenerateUserBankAccountTokenUrlResponse {
  url: string;
}

export interface UserBankAccountFilters {
  companyId: Company['id'];
  source: InstitutionSource;
  statuses?: UserBankAccountStatus[];
  userId?: User['id'];
}

interface CompareUserDataProperties {
  firstName: string | null;
  lastName: string | null;
  birthDate: string | null;
  phoneNumber: string | null;
  email: string | null;
}

export interface CompareUserData {
  swanUserData: CompareUserDataProperties;
  swanMembershipData: CompareUserDataProperties;
}

export const UserBankAccountQueryKeys = {
  all: ['UserBankAccounts'],
  byCompany: (companyId: string) => ['UserBankAccounts', 'byCompany', companyId],
  list: (filters: UserBankAccountFilters) => [...UserBankAccountQueryKeys.all, filters, 'list'],
  compareUserData: (id: string) => [...UserBankAccountQueryKeys.all, 'compareUserData', id],
};
